export enum StatusMovimentacaoCadastralManual {
  EmAndamento,
  AguardandoProvedor,
  Erro,
  Sucesso,
}
